'use client';

import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import { fetchAdminMe } from '@/app/admin/lib/api';
import type { AdminMe } from '@/types/admin';

interface UseAdminGuardReturn {
  me: AdminMe | null;
  isLoading: boolean;
}

/**
 * 運営スタッフ(IsPlatformAdmin)のガード。
 * admin_session 起点の /admin/me を叩き、非スタッフ/未認証は /admin/login へ送る。
 * 顧客アプリの /auth/me は使わない。
 */
export function useAdminGuard(): UseAdminGuardReturn {
  const router = useRouter();
  const [me, setMe] = useState<AdminMe | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      const result = await fetchAdminMe();
      if (!active) return;

      if (result.data?.IsPlatformAdmin) {
        setMe(result.data);
        setIsLoading(false);
      } else {
        router.replace('/admin/login');
      }
    })();
    return () => {
      active = false;
    };
  }, [router]);

  return { me, isLoading };
}
